'use strict';

var JSConstants = require('_core_ext/pages/content/constants');
var hashMarker = window.location.hash,
    initDelay = 1000;

/**
 * @private
 * @function
 * @description Open certain accordion item
 */

function openAccordion(item) {
    var accordionItem = $(item).next(JSConstants.CLASS_TOGGLE);
    if (!accordionItem.hasClass(JSConstants.CLASS_EXPANDED)) {
        accordionItem.trigger('click');
    }
    if (accordionItem.parents().hasClass(JSConstants.CLASS_INNER.substring(1))) {
        var $innerAccordionElement = accordionItem.parents(JSConstants.CLASS_INNER);
        var $closestElement = $innerAccordionElement.parents(JSConstants.CLASS_PARENT).find(JSConstants.CLASS_TOGGLE).first();
        $closestElement.trigger('click');
    }
}

/**
 * @private
 * @function
 * @description Triggers hash anchor scrolling
 */

function triggerHash() {
    var hash = window.location.hash;
    window.location.hash = '';
    window.location.hash = hash;
}

/**
 * @private
 * @function
 * @description Binds events to the content pages
 */

function initializeEvents() {
    $(JSConstants.CLASS_ANCHOR).on('click', function() {
        openAccordion($(this).attr('href'));
    });

    if (hashMarker) {
        setTimeout(function() {
           openAccordion(hashMarker);
           triggerHash();
        }, initDelay);
    }
}

exports.init = function () {
    initializeEvents();
};
